import { createDrawingObject, replaceLastPoint } from "../shared";
const Curve = {
    name: "curve",
    createDraft: (startPoint) => createDrawingObject("curve", [startPoint, startPoint, startPoint]),
    updateDraft: (draft, nextPoint) => replaceLastPoint(draft, nextPoint),
    render: () => undefined,
};
export default Curve;
